import { useNavigate } from "react-router-dom";

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-3xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20composition%20in%20soft%20beige%20sand%20and%20dusty%20rose%20tones%20with%20subtle%20product%20silhouettes%20blending%20into%20the%20background%2C%20dreamy%20editorial%20aesthetic%2C%20gentle%20light%20wash%20effect%2C%20elegant%20minimal%20atmosphere%2C%20high%20resolution%2C%20sophisticated%20fashion%20editorial%20feel&width=1200&height=600&seq=cta-banner-v2-2026&orientation=landscape"
            alt="Start exploring the AllChinaBuy Spreadsheet with curated products"
            title="AllChinaBuy Spreadsheet — Start Exploring Today"
            className="w-full h-48 md:h-64 object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        </div>

        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4 leading-tight">
          Start Exploring the Latest
          <br />
          <span className="text-accent-600 italic">AllChinaBuy Spreadsheet</span>
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto mb-10">
          Find the best products, compare sellers, discover quality picks, and explore the latest updates — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-10 py-4 rounded-full bg-foreground-900 text-white font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            AllChinaBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-10 py-4 rounded-full border-2 border-foreground-900 text-foreground-900 font-semibold text-sm hover:bg-foreground-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
          <button
            onClick={() => navigate("/best-allchinabuy-spreadsheet-guide")}
            className="px-10 py-4 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Free Shopping Guide
          </button>
        </div>
      </div>
    </section>
  );
}